module.exports = __webpack_public_path__ + "static/img/ship-water.b7af57a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/headers/ship-water.jpg
// module id = 193
// module chunks = 0